import React, { Component } from 'react';
import 'materialize-css/dist/css/materialize.min.css';
import M from "materialize-css";
import * as CONS from '../CONS'
import jwt from 'jsonwebtoken';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import logo_regalo from '../img/1x/logo_regalo.png'
import Navigation from './Navigation';
import '../style/ChooseGift.css'
import title_redimir from '../img/1x/title_redimir.png'

class ChooseGift extends Component {

    constructor(props) {
        super(props);
        if (!localStorage.getItem('jwtToken')) {
            this.props.history.push("/login");
        } else {
            var token = localStorage.getItem("jwtToken");
            const tokenDec = jwt.decode(token);
            if (tokenDec.level < 10)
                this.props.history.push("/login");
        }
    }

    state = {
        status: '',
        gift: 0,
        user: 0,
        boss: 0,
        point_user: 0,
        admin_staff: 1,
        gift_list: [],
        error: false
    };


    async getUser() {
        try {
            var token = localStorage.getItem("jwtToken");
            if (!token) { return; }
            const id_user = jwt.decode(token).id_user;

            const response = await fetch(localStorage.getItem("api") + '/user/' + id_user, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            });

            const data = await response.json();
            this.setState({
                user: data.id_user,
                boss: data.boss,
                point_user: data.point,
                admin_staff: data.admin_staff
            })
        } catch (err) {
            console.log(err.toString())
            return;
        }
    }

    // Manda la solicitud al servidor por POST
    async insertRequest(gift, value) {
        const { comment, request_date } = value;
        const { user, boss } = this.state;
        try {
            const response = await fetch(localStorage.getItem("api") + '/request_gift/', {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),

                body: JSON.stringify(
                    { user, boss, gift, comment, request_date }
                )
            });
            const data = await response.json();
            this.setState({ status: data.status, error: false });
        } catch (err) {
            console.log(err);
            this.setState({ status: CONS.err_server, error: true });
        }
    }

    // Reduce puntos
    // Cuando el empleado escoje un regalo, sus puntos son descontados
    async reducePoint(point) {
        var newPoint = this.state.point_user - point;
        if (newPoint < 0)
            return;

        try {
            const response = await fetch(localStorage.getItem("api") + '/user/point/' + this.state.user, {
                method: 'PUT',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),

                body: JSON.stringify(
                    { point: newPoint }
                )
            });
            const data = await response.json();
            this.setState({ status: data.status });

            this.getUser();
            this.fetchGiftList();
        } catch (err) {
            console.log(err);
            this.setState({ status: CONS.err_server });
        }
    }

    /*
        Selecciona el regalo a reclamar
        Si tiene suficientes puntos: 
            El usuario debe escribir un comentario
            Crea el request gift 
            y se le reducen los puntos respectivos
        Si no tiene suficientes puntos:
            Muestra la ventana warning
    */
    async setChooseGift(gift) {
        const MySwal = withReactContent(Swal);

        if (this.state.point_user >= gift.point) {
            Swal.fire({
                title: 'Comenta los detalles y cuando deseas redimir este beneficio',
                input: 'textarea',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                html:
                    "<div class='row'>" +
                    "<p class='col s6'>Fecha redención (opcional)</p>" +
                    "<input type='date' id='request_date' name='request_date' " +
                    "class='col s6' value='' />" +
                    "</div>",
                showCancelButton: true,
                confirmButtonText: 'Enviar solicitud',
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                inputValidator: (value) => {
                    if (!value) {
                        return 'Recuerda detallar porque deseas este beneficio'
                    } else if (value.length > 300) {
                        return 'El comentario supera los 300 carácteres'
                    }
                },
                preConfirm: (value) => {
                    return {
                        "comment": value,
                        "request_date": document.getElementById('request_date').value,
                    }
                }
            }).then((result) => {
                if (result.dismiss) {
                    return;
                }
                if (result.value.comment) {
                    result.value.request_date = result.value.request_date ? result.value.request_date : null;
                    if (this.state.point_user >= gift.point) {
                        this.insertRequest(gift.id_gift, result.value);
                        console.log(this.state.error, gift.point)
                        if (this.state.error) {
                            MySwal.fire({
                                title: "Error",
                                type: 'warning',
                                timer: 3000
                            })
                        } else {
                            this.reducePoint(gift.point);

                            MySwal.fire({
                                title: "Solicitud enviada",
                                text: "Solicitud enviada",
                                type: 'success',
                                timer: 3000
                            })
                        }
                    } else {
                        MySwal.fire({
                            title: "No tienes suficientes puntos",
                            type: 'warning',
                            timer: 3000
                        })
                    }
                }
            });
        } else {
            MySwal.fire({
                title: "No tienes suficientes puntos",
                type: 'warning',
                timer: 3000
            })
        }
    }


    //  Llama al server por get y trae el listado de regalos activos
    //  También actualiza el listado
    async fetchGiftList() {
        try {
            const response = await fetch(localStorage.getItem("api") + '/gift/active', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            })
            const data = await response.json();
            this.setState({ gift_list: data });
        } catch (err) {
            console.log(err);
            this.setState({ status: CONS.err_server });
        }
    }


    //  Actualiza el estado de los Checkbox
    handleCheckBoxChanged = (e) => {
        this.setState({
            [e.target.name]: e.target.checked
        });
    }

    //  Actualiza el estado de los Input
    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    componentDidMount() {
        this.getUser();
        this.fetchGiftList();

        var elems = document.querySelectorAll('input#name, textarea');
        M.CharacterCounter.init(elems);
    }

    render() {
        const { gift_list, admin_staff } = this.state;

        // Muestra los beneficios
        // Si es admin (admin_staff === 0) los muestra todos,
        // Sino los separa si es administrativo u operativo
        const tableGift =
            admin_staff === 0 ?
                gift_list
                    .map(g =>
                        <tr key={g.id_gift}>
                            <td>
                                <img className="col" src={require('../img/beneficios/' + (g.image ? g.image : 'ico_default.png'))} alt={g.image}></img>
                            </td>
                            <td className="beneficio_name">
                                {g.name}
                            </td>
                            <td>{g.description}</td>
                            <td>{g.point}</td>
                            <td>
                                {
                                    g.id_gift_state === 3 ? <label className="center">No disponible</label>
                                        :
                                        <a href="#!" onClick={() => this.setChooseGift(g)}>
                                            <img src={logo_regalo} alt=""></img>
                                        </a>
                                }
                            </td>
                        </tr>
                    )
                : gift_list
                    .filter(g => g.admin_staff === 0 || g.admin_staff === admin_staff)
                    .map(g =>
                        <tr key={g.id_gift}>
                            <td>
                                <img className="col" src={require('../img/beneficios/' + (g.image ? g.image : 'ico_default.png'))} alt={g.image}></img>
                            </td>
                            <td className="beneficio_name">
                                {g.name}
                            </td>
                            <td>{g.description}</td>
                            <td>{g.point}</td>
                            <td>
                                {
                                    g.id_gift_state === 3 ? <label className="center">No disponible</label>
                                        :
                                        <a href="#!" onClick={() => this.setChooseGift(g)}>
                                            <img src={logo_regalo} alt=""></img>
                                        </a>
                                }
                            </td>
                        </tr>
                    );

        return (
            <React.Fragment>
                <div className="shape-border-left hide-on-med-and-down"></div>
                <Navigation></Navigation>
                <div id="ChooseGift" className="container">
                    <img src={title_redimir} className="responsive-img" alt="title_redimir"></img>

                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Beneficio</th>
                                <th>Descripción</th>
                                <th>Puntos</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableGift}
                        </tbody>
                    </table>
                </div>
            </React.Fragment>

        )
    }

}

export default ChooseGift;